export default "__VITE_ASSET__Dhd_fgx0__"